(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "688829c01be78753280960d2";
              window.beaePageSetting.pageTitle = "Early Access to the Limited Edition Father's Day Collection"; 
              window.beaePageSetting.pageType = "page";

          let js_NLLGS5BU = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-ygokfx34section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ygokfx34',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ygokfx34');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ygokfx34: ', ex)
      };
    

      try {
        let argid = 'beae-jiyfm02mblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jiyfm02m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jiyfm02m');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jiyfm02m: ', ex)
      };
    

      try {
        let argid = 'beae-7p4ry7bvblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7p4ry7bv',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7p4ry7bv');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7p4ry7bv: ', ex)
      };
    

      try {
        let argid = 'beae-thfaqpgzblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-thfaqpgz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-thfaqpgz');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-thfaqpgz: ', ex)
      };
    

      try {
        let argid = 'beae-djpw7cl5block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-djpw7cl5',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-djpw7cl5');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-djpw7cl5: ', ex)
      };
    

      try {
        let argid = 'beae-2kigctombutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2kigctom',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2kigctom');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2kigctom: ', ex)
      };
    

      try {
        let argid = 'beae-9ia1yhniblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9ia1yhni',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9ia1yhni');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9ia1yhni: ', ex)
      };
    

      try {
        let argid = 'beae-v0m32t6nsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-v0m32t6n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-v0m32t6n');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-v0m32t6n: ', ex)
      };
    

      try {
        let argid = 'beae-v9uqod2gblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-v9uqod2g',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-v9uqod2g');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-v9uqod2g: ', ex)
      };
    

      try {
        let argid = 'beae-zerryq0pblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zerryq0p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zerryq0p');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zerryq0p: ', ex)
      };
    

      try {
        let argid = 'beae-ievgpa7fsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ievgpa7f',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ievgpa7f');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ievgpa7f: ', ex)
      };
    

      try {
        let argid = 'beae-930ihgomblock-imageloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-930ihgom',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-930ihgom');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-930ihgom: ', ex)
      };
    

      try {
        let argid = 'beae-lvvuarcsblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lvvuarcs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lvvuarcs');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lvvuarcs: ', ex)
      };
    

      try {
        let argid = 'beae-930ihgomblock-imageloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-930ihgom',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-930ihgom');
        args.el = args.els[1];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-930ihgom: ', ex)
      };
    

      try {
        let argid = 'beae-lvvuarcsblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lvvuarcs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lvvuarcs');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lvvuarcs: ', ex)
      };
    

      try {
        let argid = 'beae-930ihgomblock-imageloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-930ihgom',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-930ihgom');
        args.el = args.els[2];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-930ihgom: ', ex)
      };
    

      try {
        let argid = 'beae-lvvuarcsblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lvvuarcs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lvvuarcs');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lvvuarcs: ', ex)
      };
    

      try {
        let argid = 'beae-930ihgomblock-imageloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-930ihgom',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-930ihgom');
        args.el = args.els[3];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-930ihgom: ', ex)
      };
    

      try {
        let argid = 'beae-lvvuarcsblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lvvuarcs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lvvuarcs');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lvvuarcs: ', ex)
      };
    

      try {
        let argid = 'beae-930ihgomblock-imageloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-930ihgom',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-930ihgom');
        args.el = args.els[4];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-930ihgom: ', ex)
      };
    

      try {
        let argid = 'beae-lvvuarcsblock-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lvvuarcs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lvvuarcs');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lvvuarcs: ', ex)
      };
    

      try {
        let argid = 'beae-v25mbouvsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-v25mbouv',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-v25mbouv');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-v25mbouv: ', ex)
      };
    

      try {
        let argid = 'beae-txxlyd48block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-txxlyd48',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-txxlyd48');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-txxlyd48: ', ex)
      };
    

      try {
        let argid = 'beae-gdvzr5tsblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gdvzr5ts',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gdvzr5ts');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gdvzr5ts: ', ex)
      };
    

      try {
        let argid = 'beae-8ncfmiztblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8ncfmizt',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8ncfmizt');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8ncfmizt: ', ex)
      };
    

      try {
        let argid = 'beae-nk6plrhxblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nk6plrhx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nk6plrhx');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nk6plrhx: ', ex)
      };
    

      try {
        let argid = 'beae-0p54vj7lbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0p54vj7l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0p54vj7l');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0p54vj7l: ', ex)
      };
    

      try {
        let argid = 'beae-p9ii1eissection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p9ii1eis',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p9ii1eis');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p9ii1eis: ', ex)
      };
    

      try {
        let argid = 'beae-aqepe1kasection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-aqepe1ka',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-aqepe1ka');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-aqepe1ka: ', ex)
      };
    

      try {
        let argid = 'beae-e6zt1ozgblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-e6zt1ozg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-e6zt1ozg');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-e6zt1ozg: ', ex)
      };
    

      try {
        let argid = 'beae-guif7oxmblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-guif7oxm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-guif7oxm');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-guif7oxm: ', ex)
      };
    

      try {
        let argid = 'beae-e6zt1ozgblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-e6zt1ozg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-e6zt1ozg');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-e6zt1ozg: ', ex)
      };
    

      try {
        let argid = 'beae-guif7oxmblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-guif7oxm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-guif7oxm');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-guif7oxm: ', ex)
      };
    

      try {
        let argid = 'beae-e6zt1ozgblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-e6zt1ozg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-e6zt1ozg');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-e6zt1ozg: ', ex)
      };
    

      try {
        let argid = 'beae-guif7oxmblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-guif7oxm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-guif7oxm');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-guif7oxm: ', ex)
      };
    

      try {
        let argid = 'beae-qt9egt4zsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qt9egt4z',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qt9egt4z');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qt9egt4z: ', ex)
      };
    

      try {
        let argid = 'beae-eoh6lzzbblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eoh6lzzb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eoh6lzzb');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eoh6lzzb: ', ex)
      };
    

      try {
        let argid = 'beae-00xd4ewgblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-00xd4ewg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-00xd4ewg');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-00xd4ewg: ', ex)
      };
    

      try {
        let argid = 'beae-7ouejn75block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7ouejn75',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7ouejn75');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7ouejn75: ', ex)
      };
    

      try {
        let argid = 'beae-ywt29t45block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ywt29t45',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ywt29t45');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ywt29t45: ', ex)
      };
    

      try {
        let argid = 'beae-pxy09ktcbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pxy09ktc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pxy09ktc');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pxy09ktc: ', ex)
      };
    

      try {
        let argid = 'beae-jxtz1ihosection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jxtz1iho',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jxtz1iho');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jxtz1iho: ', ex)
      };
    

      try {
        let argid = 'beae-ke8buetxblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ke8buetx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ke8buetx');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ke8buetx: ', ex)
      };
    

      try {
        let argid = 'beae-jj1odp1oblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jj1odp1o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jj1odp1o');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jj1odp1o: ', ex)
      };
    

      try {
        let argid = 'beae-xopu8zdosection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xopu8zdo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xopu8zdo');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xopu8zdo: ', ex)
      };
    

      try {
        let argid = 'beae-04hwzucpblock-imageloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-04hwzucp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-04hwzucp');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-04hwzucp: ', ex)
      };
    

      try {
        let argid = 'beae-0q2gezqeblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0q2gezqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0q2gezqe');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0q2gezqe: ', ex)
      };
    

      try {
        let argid = 'beae-04hwzucpblock-imageloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-04hwzucp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-04hwzucp');
        args.el = args.els[1];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-04hwzucp: ', ex)
      };
    

      try {
        let argid = 'beae-0q2gezqeblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0q2gezqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0q2gezqe');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0q2gezqe: ', ex)
      };
    

      try {
        let argid = 'beae-04hwzucpblock-imageloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-04hwzucp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-04hwzucp');
        args.el = args.els[2];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-04hwzucp: ', ex)
      };
    

      try {
        let argid = 'beae-0q2gezqeblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0q2gezqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0q2gezqe');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0q2gezqe: ', ex)
      };
    

      try {
        let argid = 'beae-04hwzucpblock-imageloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-04hwzucp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-04hwzucp');
        args.el = args.els[3];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-04hwzucp: ', ex)
      };
    

      try {
        let argid = 'beae-0q2gezqeblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0q2gezqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0q2gezqe');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0q2gezqe: ', ex)
      };
    

      try {
        let argid = 'beae-04hwzucpblock-imageloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-04hwzucp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-04hwzucp');
        args.el = args.els[4];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-04hwzucp: ', ex)
      };
    

      try {
        let argid = 'beae-0q2gezqeblock-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0q2gezqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0q2gezqe');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0q2gezqe: ', ex)
      };
    

      try {
        let argid = 'beae-04hwzucpblock-imageloop-5',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-04hwzucp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-04hwzucp');
        args.el = args.els[5];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-04hwzucp: ', ex)
      };
    

      try {
        let argid = 'beae-0q2gezqeblock-textloop-5',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0q2gezqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0q2gezqe');
        args.el = args.els[5];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0q2gezqe: ', ex)
      };
    

      try {
        let argid = 'beae-04hwzucpblock-imageloop-6',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-04hwzucp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-04hwzucp');
        args.el = args.els[6];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-04hwzucp: ', ex)
      };
    

      try {
        let argid = 'beae-0q2gezqeblock-textloop-6',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0q2gezqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0q2gezqe');
        args.el = args.els[6];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0q2gezqe: ', ex)
      };
    

      try {
        let argid = 'beae-z16oaotssection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-z16oaots',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-z16oaots');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-z16oaots: ', ex)
      };
    

      try {
        let argid = 'beae-7hti8bezblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7hti8bez',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7hti8bez');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7hti8bez: ', ex)
      };
    

      try {
        let argid = 'beae-54jpdlu8section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-54jpdlu8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-54jpdlu8');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-54jpdlu8: ', ex)
      };
    

      try {
        let argid = 'beae-be2zbsevblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-be2zbsev',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-be2zbsev');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-be2zbsev: ', ex)
      };
    

      try {
        let argid = 'beae-r08tgaxkblock-tabs',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-r08tgaxk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-r08tgaxk');
        args.el = args.els[0];
        ((data) => { let tabs=data.el.querySelectorAll(".beae-tab-item"),contents=data.el.querySelectorAll(".beae-tab-content"),rightside=data.el.querySelectorAll(".beae-rightside"),accordions=data.el.querySelectorAll(".beae-accordion-title--mobile"),activeTab=data.activeTab,toggleImg=data.toggleImg,layout=data.layout,accordionMode=data.accordionMode;function resetActive(){tabs.forEach(b=>b.classList.remove("active")),contents.forEach(b=>b.classList.remove("active")),accordions.forEach(b=>b.classList.remove("active")),toggleImg&&rightside.forEach(b=>b.classList.remove("active")),contents.forEach(b=>{const h=b.querySelector(".beae-accordion-body").style;layout=="accordions"?h.maxHeight="0px":(h.transform="scaleY(0)",h.opacity="0")})}function setActive(b){tabs[b].classList.add("active"),contents[b].classList.add("active"),accordions[b].classList.add("active"),toggleImg&&rightside[b].classList.add("active");const h=contents[b].querySelector(".beae-accordion-body");if(h){const p=h.style;layout=="accordions"?p.maxHeight=data.mode.value=="builder"?"":h.scrollHeight+"px":(p.transform="scaleY(1)",p.transformOrigin="top center",p.opacity="1")}}function removeActive(b){tabs[b].classList.remove("active"),contents[b].classList.remove("active"),accordions[b].classList.remove("active"),toggleImg&&rightside[b].classList.remove("active");const h=contents[b].querySelector(".beae-accordion-body").style;layout=="accordions"?h.maxHeight="0px":(h.transform="scaleY(0)",h.opacity="0")}resetActive(),activeTab!=="none"&&accordionMode!="popup"&&setActive(activeTab),tabs.forEach((b,h)=>{b.addEventListener("click",()=>{resetActive(),setActive(h)})});const section=data.el.closest("section.beae-section");let sectionId="";section&&(sectionId=section.getAttribute("data-sectionid"));let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(b){extOptions={},console.error(b)}if(accordions.forEach((b,h)=>{b.addEventListener("click",()=>{if(accordionMode=="popup"&&data.mode.value!="builder"){const p=b.closest(".beae-tab-content");if(p){let f=document.createElement("div");f.innerHTML=`
                            <h3 class="beae-popup__content-title">${b.querySelector("span").innerHTML}</h3>
                            <div class="beae-popup__content-body ${data.id}">${p.querySelector(".beae-accordion-body").innerHTML}</div>
                            `,window.BeaePopupLibrary.createPopup(f,{layout:extOptions.layout?extOptions.layout:"right",width:extOptions.width?extOptions.width:"400px",layoutMobile:extOptions.layoutMobile?extOptions.layoutMobile:"bottom",sectionId})}}else accordionMode=="single"?(resetActive(),setActive(h)):b.classList.contains("active")?removeActive(h):setActive(h)})}),layout=="tabs"){const b=data.el.querySelector(".beae-tab-contents"),h=b.querySelectorAll(".beae-tab-content-wrp");let p=0,f=-1;h.forEach((w,g)=>{const y=w.offsetHeight;y>p&&(f=g,p=y)}),new ResizeObserver(()=>{b.style.setProperty("--beae-tabs-max-height",`${h[f].offsetHeight}px`)}).observe(h[f])} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-r08tgaxk: ', ex)
      };
    

      try {
        let argid = 'beae-eqqfy96oblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eqqfy96o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eqqfy96o');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eqqfy96o: ', ex)
      };
    

      try {
        let argid = 'beae-vust096gblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vust096g',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vust096g');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vust096g: ', ex)
      };
    

      try {
        let argid = 'beae-0bzz4y34block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0bzz4y34',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0bzz4y34');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0bzz4y34: ', ex)
      };
    

      try {
        let argid = 'beae-jk9avhlyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jk9avhly',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jk9avhly');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jk9avhly: ', ex)
      };
    

      try {
        let argid = 'beae-8ve8nukmblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8ve8nukm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8ve8nukm');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8ve8nukm: ', ex)
      };
    }; if (window.BEAEBASE) {js_NLLGS5BU()} else {window.BEAEPAGEJS.push(js_NLLGS5BU)} })(); 